import {StyleSheet} from "aphrodite";
import * as React from "react";
import {useState} from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {sizing} from "@khanacademy/wonder-blocks-tokens";

import EmailGeneralSection from "./email-general-section.tsx";
import EmailReportsSection from "./email-reports-section.tsx";
import NewslettersSection from "./newsletters-section.tsx";
import NotificationsSection from "./notifications-section.tsx";
import PrimaryEmailSection from "./primary-email-section.tsx";
import {type SubscriptionTarget} from "./types.ts";

interface SettingsProps {
    token: string | null | undefined;
    targetKaid: string | null | undefined;
    target: SubscriptionTarget;
}

export const EmailSettingsForm: React.FC<SettingsProps> = ({
    token,
    targetKaid,
    target,
}) => {
    const {
        allEmailSubscription,
        answerNotificationEmailSubscription,
        newAssignmentNotificationEmailSubscription,
        allStudentsCoachReportEmailSubscription,
        streaksEmailSubscription,
        parentReportEmailSubscriptions,
        studentListEmailSubscriptions,
        email,
        authEmails,
        hasStudents,
        hasChildren,
        hasClasses,
    } = target;
    const [emailEnabled, setEmailEnabled] = useState(
        !!allEmailSubscription?.checked,
    );

    const hasAvailableEmailReports = hasChildren || hasStudents;

    return (
        <View style={styles.sectionContainer}>
            <View>
                <EmailGeneralSection
                    emailEnabled={emailEnabled}
                    subscriptionKey={allEmailSubscription?.key}
                    onChange={setEmailEnabled}
                    footer={
                        <>
                            {email && authEmails && (
                                <React.Fragment>
                                    <PrimaryEmailSection
                                        email={email}
                                        authEmails={authEmails}
                                    />
                                </React.Fragment>
                            )}
                        </>
                    }
                />
            </View>

            {emailEnabled && (
                <View>
                    <NotificationsSection
                        answerNotification={answerNotificationEmailSubscription}
                        assignmentNotification={
                            newAssignmentNotificationEmailSubscription
                        }
                        streaksNotification={streaksEmailSubscription}
                    />
                    <View style={styles.divider} />

                    {/* Hide this section AND the divider if we don't have
                    anything to display in it. */}
                    {hasAvailableEmailReports && (
                        <React.Fragment>
                            <EmailReportsSection
                                hasStudents={!!hasStudents && !!hasClasses}
                                allStudentsList={
                                    allStudentsCoachReportEmailSubscription
                                }
                                studentLists={studentListEmailSubscriptions}
                                hasChildren={!!hasChildren}
                                childrenList={parentReportEmailSubscriptions}
                            />
                            <View style={[styles.divider]} />
                        </React.Fragment>
                    )}
                    <NewslettersSection token={token} targetKaid={targetKaid} />
                </View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    sectionContainer: {
        gap: sizing.size_240,
    },
    divider: {
        marginBlockEnd: sizing.size_240,
    },
});

export default EmailSettingsForm;
